<template>
  <component
    :is="name"
    :fill="fill"
    :size="size"
  />
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from 'vue';
import { iconProps } from './IconProps';

export default defineComponent({
  name: 'Icon',
  components: {
    IconAbsent: defineAsyncComponent(() => import('./icons/absent/IconAbsent.vue')),
    IconAmericanExpress: defineAsyncComponent(() => import('./icons/american-express/IconAmericanExpress.vue')),
    IconAnniversary: defineAsyncComponent(() => import('./icons/anniversary/IconAnniversary.vue')),
    IconApartment: defineAsyncComponent(() => import('./icons/apartment/IconApartment.vue')),
    IconApplePay: defineAsyncComponent(() => import('./icons/apple-pay/IconApplePay.vue')),
    IconArrowDown: defineAsyncComponent(() => import('./icons/arrow/IconArrowDown.vue')),
    IconArrowLeft: defineAsyncComponent(() => import('./icons/arrow/IconArrowLeft.vue')),
    IconArrowRight: defineAsyncComponent(() => import('./icons/arrow/IconArrowRight.vue')),
    IconArrowUp: defineAsyncComponent(() => import('./icons/arrow/IconArrowUp.vue')),
    IconBasket: defineAsyncComponent(() => import('./icons/basket/IconBasket.vue')),
    IconBeer: defineAsyncComponent(() => import('./icons/beer/IconBeer.vue')),
    IconBell: defineAsyncComponent(() => import('./icons/bell/IconBell.vue')),
    IconBirthday: defineAsyncComponent(() => import('./icons/birthday/IconBirthday.vue')),
    IconBonus: defineAsyncComponent(() => import('./icons/bonus/IconBonus.vue')),
    IconBouquet: defineAsyncComponent(() => import('./icons/bouquet/IconBouquet.vue')),
    IconBriefcase: defineAsyncComponent(() => import('./icons/briefcase/IconBriefcase.vue')),
    IconBuilding: defineAsyncComponent(() => import('./icons/building/IconBuilding.vue')),
    IconCalendar: defineAsyncComponent(() => import('./icons/calendar/IconCalendar.vue')),
    IconCalendarArrow: defineAsyncComponent(() => import('./icons/calendar-tomorrow/IconCalendarArrow.vue')),
    IconCalendarCheck: defineAsyncComponent(() => import('./icons/calendar-today/IconCalendarCheck.vue')),
    IconCall: defineAsyncComponent(() => import('./icons/call/IconCall.vue')),
    IconCard: defineAsyncComponent(() => import('./icons/card/IconCard.vue')),
    IconCardDesign: defineAsyncComponent(() => import('./icons/card-design/IconCardDesign.vue')),
    IconCardHorizontal: defineAsyncComponent(() => import('./icons/card-horizontal/IconCardHorizontal.vue')),
    IconCardVertical: defineAsyncComponent(() => import('./icons/card/IconCardVertical.vue')),
    IconCelebrate: defineAsyncComponent(() => import('./icons/celebrate/IconCelebrate.vue')),
    IconChampagne: defineAsyncComponent(() => import('./icons/champagne/IconChampagne.vue')),
    IconChapel: defineAsyncComponent(() => import('./icons/chapel/IconChapel.vue')),
    IconCheck: defineAsyncComponent(() => import('./icons/check/IconCheck.vue')),
    IconChocolate: defineAsyncComponent(() => import('./icons/chocolate/IconChocolate.vue')),
    IconChristmas: defineAsyncComponent(() => import('./icons/christmas/IconChristmas.vue')),
    IconChristmasDecoration: defineAsyncComponent(
      () => import('./icons/christmas-decoration/IconChristmasDecoration.vue'),
    ),
    IconChristmasFlower: defineAsyncComponent(() => import('./icons/christmas-flower/IconChristmasFlower.vue')),
    IconChurch: defineAsyncComponent(() => import('./icons/church/IconChurch.vue')),
    IconClock: defineAsyncComponent(() => import('./icons/clock/IconClock.vue')),
    IconColorCard: defineAsyncComponent(() => import('./icons/color-card/IconColorCard.vue')),
    IconColorVideo: defineAsyncComponent(() => import('./icons/color-video/IconColorVideo.vue')),
    IconCombination: defineAsyncComponent(() => import('./icons/combination/IconCombination.vue')),
    IconCookie: defineAsyncComponent(() => import('./icons/cookie/IconCookie.vue')),
    IconCopy: defineAsyncComponent(() => import('./icons/copy/IconCopy.vue')),
    IconCoupon: defineAsyncComponent(() => import('./icons/coupon/IconCoupon.vue')),
    IconDankort: defineAsyncComponent(() => import('./icons/dankort/IconDankort.vue')),
    IconDove: defineAsyncComponent(() => import('./icons/dove/IconDove.vue')),
    IconError: defineAsyncComponent(() => import('./icons/error/IconError.vue')),
    IconFacebook: defineAsyncComponent(() => import('./icons/facebook/IconFacebook.vue')),
    IconFilter: defineAsyncComponent(() => import('./icons/filter/IconFilter.vue')),
    IconFlowers: defineAsyncComponent(() => import('./icons/flowers/IconFlowers.vue')),
    IconFuneral: defineAsyncComponent(() => import('./icons/funeral/IconFuneral.vue')),
    IconGetWell: defineAsyncComponent(() => import('./icons/get-well/IconGetWell.vue')),
    IconGift: defineAsyncComponent(() => import('./icons/gift/IconGift.vue')),
    IconGiftBasket: defineAsyncComponent(() => import('./icons/gift-basket/IconGiftBasket.vue')),
    IconGiftcard: defineAsyncComponent(() => import('./icons/giftcard/IconGiftcard.vue')),
    IconGlobe: defineAsyncComponent(() => import('./icons/globe/IconGlobe.vue')),
    IconGoodLuck: defineAsyncComponent(() => import('./icons/good-luck/IconGoodLuck.vue')),
    IconHeart: defineAsyncComponent(() => import('./icons/heart/IconHeart.vue')),
    IconHome: defineAsyncComponent(() => import('./icons/home/IconHome.vue')),
    IconHospital: defineAsyncComponent(() => import('./icons/hospital/IconHospital.vue')),
    IconHouse: defineAsyncComponent(() => import('./icons/house/IconHouse.vue')),
    IconImage: defineAsyncComponent(() => import('./icons/image/IconImage.vue')),
    IconInstagram: defineAsyncComponent(() => import('./icons/instagram/IconInstagram.vue')),
    IconInvoice: defineAsyncComponent(() => import('./icons/invoice/IconInvoice.vue')),
    IconInvoices: defineAsyncComponent(() => import('./icons/invoices/IconInvoices.vue')),
    IconLinkedIn: defineAsyncComponent(() => import('./icons/linkedIn/IconLinkedIn.vue')),
    IconLoading: defineAsyncComponent(() => import('./icons/loading/IconLoading.vue')),
    IconLock: defineAsyncComponent(() => import('./icons/lock/IconLock.vue')),
    IconMaestro: defineAsyncComponent(() => import('./icons/maestro/IconMaestro.vue')),
    IconMailHeart: defineAsyncComponent(() => import('./icons/mail-heart/IconMailHeart.vue')),
    IconMailX: defineAsyncComponent(() => import('./icons/mail-x/IconMailX.vue')),
    IconMastercard: defineAsyncComponent(() => import('./icons/mastercard/IconMastercard.vue')),
    IconMaternity: defineAsyncComponent(() => import('./icons/maternity/IconMaternity.vue')),
    IconMegaphone: defineAsyncComponent(() => import('./icons/megaphone/IconMegaphone.vue')),
    IconMenu: defineAsyncComponent(() => import('./icons/menu/IconMenu.vue')),
    IconMinus: defineAsyncComponent(() => import('./icons/minus/IconMinus.vue')),
    IconMobilePay: defineAsyncComponent(() => import('./icons/mobile-pay/IconMobilePay.vue')),
    IconMobilePayFooter: defineAsyncComponent(() => import('./icons/mobile-pay-footer/IconMobilePayFooter.vue')),
    IconMosque: defineAsyncComponent(() => import('./icons/mosque/IconMosque.vue')),
    IconMothersDay: defineAsyncComponent(() => import('./icons/mothers-day/IconMothersDay.vue')),
    IconMunicipality: defineAsyncComponent(() => import('./icons/municipality/IconMunicipality.vue')),
    IconMuseum: defineAsyncComponent(() => import('./icons/museum/IconMuseum.vue')),
    IconNoCardHorizontal: defineAsyncComponent(() => import('./icons/card/IconNoCardHorizontal.vue')),
    IconNotification: defineAsyncComponent(() => import('./icons/notification/IconNotification.vue')),
    IconPaymentCard: defineAsyncComponent(() => import('./icons/credit-card/IconPaymentCard.vue')),
    IconPencil: defineAsyncComponent(() => import('./icons/edit/IconPencil.vue')),
    IconPeople: defineAsyncComponent(() => import('./icons/people/IconPeople.vue')),
    IconPhone: defineAsyncComponent(() => import('./icons/phone/IconPhone.vue')),
    IconPin: defineAsyncComponent(() => import('./icons/pin/IconPin.vue')),
    IconPlant: defineAsyncComponent(() => import('./icons/plant/IconPlant.vue')),
    IconPlus: defineAsyncComponent(() => import('./icons/plus/IconPlus.vue')),
    IconProfile: defineAsyncComponent(() => import('./icons/profile/IconProfile.vue')),
    IconQuestion: defineAsyncComponent(() => import('./icons/question/IconQuestion.vue')),
    IconRoad: defineAsyncComponent(() => import('./icons/road/IconRoad.vue')),
    IconRocket: defineAsyncComponent(() => import('./icons/rocket/IconRocket.vue')),
    IconRose: defineAsyncComponent(() => import('./icons/rose/IconRose.vue')),
    IconSchool: defineAsyncComponent(() => import('./icons/school/IconSchool.vue')),
    IconSearch: defineAsyncComponent(() => import('./icons/search/IconSearch.vue')),
    IconSearching: defineAsyncComponent(() => import('./icons/searching/IconSearching.vue')),
    IconSelection: defineAsyncComponent(() => import('./icons/selection/IconSelection.vue')),
    IconShop: defineAsyncComponent(() => import('./icons/shop/IconShop.vue')),
    IconShow: defineAsyncComponent(() => import('./icons/show/IconShow.vue')),
    IconSizeLarge: defineAsyncComponent(() => import('./icons/size-large/IconSizeLarge.vue')),
    IconSizeSmall: defineAsyncComponent(() => import('./icons/size-small/IconSizeSmall.vue')),
    IconSizeXLarge: defineAsyncComponent(() => import('./icons/size-x-large/IconSizeXLarge.vue')),
    IconSnacks: defineAsyncComponent(() => import('./icons/snacks/IconsSnacks.vue')),
    IconStar: defineAsyncComponent(() => import('./icons/star/IconStar.vue')),
    IconSynagogue: defineAsyncComponent(() => import('./icons/synagogue/IconSynagogue.vue')),
    IconStoetBrysterne: defineAsyncComponent(() => import('./icons/stoet-brysterne/IconStoetBrysterne.vue')),
    IconThankYou: defineAsyncComponent(() => import('./icons/thank-you/IconThankYou.vue')),
    IconThinking: defineAsyncComponent(() => import('./icons/thinking/IconThinking.vue')),
    IconTrash: defineAsyncComponent(() => import('./icons/bin/IconTrash.vue')),
    IconVan: defineAsyncComponent(() => import('./icons/van/IconVan.vue')),
    IconVideo: defineAsyncComponent(() => import('./icons/video/IconVideo.vue')),
    IconVisa: defineAsyncComponent(() => import('./icons/visa/IconVisa.vue')),
    IconVisaElectron: defineAsyncComponent(() => import('./icons/visa-electron/IconVisaElectron.vue')),
    IconWarning: defineAsyncComponent(() => import('./icons/warning/IconWarning.vue')),
    IconWeddingDay: defineAsyncComponent(() => import('./icons/wedding-day/IconWeddingDay.vue')),
    IconWine: defineAsyncComponent(() => import('./icons/wine/IconWine.vue')),
    IconX: defineAsyncComponent(() => import('./icons/cross/IconX.vue')),
    IconRoundX: defineAsyncComponent(() => import('./icons/cross/IconRoundX.vue')),
    IconYoutube: defineAsyncComponent(() => import('./icons/youtube/IconYoutube.vue')),
    IconFlagSE: defineAsyncComponent(() => import('./icons/flagSE/IconFlagSE.vue')),
    IconFlagDE: defineAsyncComponent(() => import('./icons/flagDE/IconFlagDE.vue')),
    IconFlagNO: defineAsyncComponent(() => import('./icons/flagNO/IconFlagNO.vue')),
    IconFlagUS: defineAsyncComponent(() => import('./icons/flagUS/IconFlagUS.vue')),
    IconFlagFR: defineAsyncComponent(() => import('./icons/flagFR/IconFlagFR.vue')),
    IconFlagNL: defineAsyncComponent(() => import('./icons/flagNL/IconFlagNL.vue')),
    IconFlagES: defineAsyncComponent(() => import('./icons/flagES/IconFlagES.vue')),
    IconFlagAU: defineAsyncComponent(() => import('./icons/flagAU/IconFlagAU.vue')),
    IconFlagIT: defineAsyncComponent(() => import('./icons/flagIT/IconFlagIT.vue')),
    IconFlagUK: defineAsyncComponent(() => import('./icons/flagUK/IconFlagUK.vue')),
  },
  props: {
    ...iconProps,
    name: {
      type: String,
      required: true,
    },
  },
});
</script>
